import { useEffect, useState } from 'react';

export function useWindowScrollY(): number {
  const [scrollY, setScrollY] = useState(window.scrollY);
  useEffect(
    () => {
      const onScroll = () => { return setScrollY(window.scrollY); };
      // clean up code
      window.removeEventListener('scroll', onScroll);
      window.addEventListener('scroll', onScroll, { passive: true });
      return () => {
        window.removeEventListener('scroll', onScroll);
      };
    }
  );
  return scrollY;
}
